export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteHeader.vue?vue&type=template&id=1bc4fccf&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteHeader.vue?vue&type=template&id=1bc4fccf&scoped=true&
// module id = 112
// module chunks = 0